/**
 * ProductHostEntry.jsx — on a product host, `/` opens that product's registry entry.
 * Shaped by: VR-3; decisions D-VR3-01, D-VR3-02, D-VR3-03.
 * Invariants: the destination is getProductEntry. No query parameter chooses the URL.
 * Related: productSubdomains.js, AppRoutes.jsx.
 */
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getProductEntry, getProductForHost } from "config/productSubdomains";

export default function ProductHostEntry() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== "/") return;
    const product = getProductForHost(window.location.hostname, location.search);
    if (!product) return;
    const entry = getProductEntry(product);
    if (!entry) return;
    navigate(entry, { replace: true });
  }, [location.pathname, location.search, navigate]);

  return null;
}

export function ProductSubdomainReplace({ url }) {
  useEffect(() => {
    if (typeof url === "string" && url.startsWith("https://")) {
      window.location.replace(url);
    }
  }, [url]);
  return null;
}
